module.exports = __webpack_public_path__ + "static/img/1_1_3.4cc458b9.png";